module.exports = __webpack_public_path__ + "img/wrapbg8.b10edb0c.png";